module.exports = __webpack_public_path__ + "static/pic-3@2x-1fe3714752a3b96bef828671ade735aa.png";